export default "__VITE_ASSET__e1dcf342__"